import type { BlockExportMapping } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { Root } from "@/react/components/shared/BuilderUI/DefaultBlocks/Root";
import { FormButtonBlock } from "./FormButtonBlock";
import { blockToElement as FormButtonBlockToElement } from "./FormButtonBlock/blockToElement";
import { elementToBlock as FormButtonElementToBlock } from "./FormButtonBlock/elementToBlock";
import { FormContactEmailBlock } from "./FormContactEmailBlock";
import { blockToElement as FormContactEmailBlockToElement } from "./FormContactEmailBlock/blockToElement";
import { elementToBlock as FormContactEmailElementToBlock } from "./FormContactEmailBlock/elementToBlock";
import { FormContactNameBlock } from "./FormContactNameBlock";
import { blockToElement as FormContactNameBlockToElement } from "./FormContactNameBlock/blockToElement";
import { elementToBlock as FormContactNameElementToBlock } from "./FormContactNameBlock/elementToBlock";
import { FormHeadingBlock } from "./FormHeadingBlock";
import { blockToElement as FormHeadingBlockToElement } from "./FormHeadingBlock/blockToElement";
import { elementToBlock as FormHeadingElementToBlock } from "./FormHeadingBlock/elementToBlock";
import { FormLongAnswerBlock } from "./FormLongAnswerBlock";
import { blockToElement as FormLongAnswerBlockToElement } from "./FormLongAnswerBlock/blockToElement";
import { elementToBlock as FormLongAnswerElementToBlock } from "./FormLongAnswerBlock/elementToBlock";
import { FormMultipleChoiceBlock } from "./FormMultipleChoiceBlock";
import { blockToElement as FormMultipleChoiceBlockToElement } from "./FormMultipleChoiceBlock/blockToElement";
import { elementToBlock as FormMultipleChoiceElementToBlock } from "./FormMultipleChoiceBlock/elementToBlock";
import { FormParagraphBlock } from "./FormParagraphBlock";
import { blockToElement as FormParagraphBlockToElement } from "./FormParagraphBlock/blockToElement";
import { elementToBlock as FormParagraphElementToBlock } from "./FormParagraphBlock/elementToBlock";
import { FormShortAnswerBlock } from "./FormShortAnswerBlock";
import { blockToElement as FormShortAnswerBlockToElement } from "./FormShortAnswerBlock/blockToElement";
import { elementToBlock as FormShortAnswerElementToBlock } from "./FormShortAnswerBlock/elementToBlock";
import { FormSingleChoiceBlock } from "./FormSingleChoiceBlock";
import { blockToElement as FormSingleChoiceBlockToElement } from "./FormSingleChoiceBlock/blockToElement";
import { elementToBlock as FormSingleChoiceElementToBlock } from "./FormSingleChoiceBlock/elementToBlock";
import { FormStackBlock } from "./FormStackBlock";
import { blockToElement as FormStackBlockToElement } from "./FormStackBlock/blockToElement";
import { elementToBlock as FormStackElementToBlock } from "./FormStackBlock/elementToBlock";

export const formBlocks: BlockExportMapping = {
  root: Root,
  FormContactEmailBlock,
  FormContactNameBlock,
  FormHeadingBlock,
  FormShortAnswerBlock,
  FormLongAnswerBlock,
  FormSingleChoiceBlock,
  FormMultipleChoiceBlock,
  FormParagraphBlock,
  FormButtonBlock,
  FormStackBlock,
};

// Registry of block conversion functions
export const blockConverters = {
  FormContactNameBlock: {
    elementToBlock: FormContactNameElementToBlock,
    blockToElement: FormContactNameBlockToElement,
  },
  FormContactEmailBlock: {
    elementToBlock: FormContactEmailElementToBlock,
    blockToElement: FormContactEmailBlockToElement,
  },
  FormHeadingBlock: {
    elementToBlock: FormHeadingElementToBlock,
    blockToElement: FormHeadingBlockToElement,
  },
  FormLongAnswerBlock: {
    elementToBlock: FormLongAnswerElementToBlock,
    blockToElement: FormLongAnswerBlockToElement,
  },
  FormParagraphBlock: {
    elementToBlock: FormParagraphElementToBlock,
    blockToElement: FormParagraphBlockToElement,
  },
  FormShortAnswerBlock: {
    elementToBlock: FormShortAnswerElementToBlock,
    blockToElement: FormShortAnswerBlockToElement,
  },
  FormSingleChoiceBlock: {
    elementToBlock: FormSingleChoiceElementToBlock,
    blockToElement: FormSingleChoiceBlockToElement,
  },
  FormMultipleChoiceBlock: {
    elementToBlock: FormMultipleChoiceElementToBlock,
    blockToElement: FormMultipleChoiceBlockToElement,
  },
  FormButtonBlock: {
    elementToBlock: FormButtonElementToBlock,
    blockToElement: FormButtonBlockToElement,
  },
  FormStackBlock: {
    elementToBlock: FormStackElementToBlock,
    blockToElement: FormStackBlockToElement,
  },
};
